





























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApiService } from '@/services/ApiService';
import OrderTemplatePdfButton from '@/order-template/OrderTemplatePdfButton.vue';
import { DependencyService } from '@/services/DependencyService';
import MatomoEvents from '@/matomo/events/MatomoEvents';

@Component({
  components: { OrderTemplatePdfButton }
})
export default class OrderTemplateButtons extends Vue {
  public readonly optionAmount: string = 'amount';
  public readonly optionPdf: string = 'pdf';
  private addedToCart = false;

  private cartService = DependencyService.defaultCartService();

  @Prop({ required: false, default: 'true' })
  private localShowPdfButton: string;

  // set true if just the add all products button should be shown
  @Prop({ required: false, default: 'false' })
  private localShowJustAllToCartBtn: string;

  private chosenOption: string = this.optionAmount;
  private showOptions: boolean = false;

  public toggleShowOptions() {
    this.showOptions = !this.showOptions;
    (this.$refs.pdfButton as OrderTemplatePdfButton).open = false;
  }

  public setChosenOption(option: string) {
    this.chosenOption = option;
    switch (option) {
      case this.optionPdf:
        (this.$refs.pdfButton as OrderTemplatePdfButton).open = true;
        break;
      case this.optionAmount:
        this.dropOrderTemplateItemsAmount();
        break;
      default:
        break;
    }
    this.showOptions = false;
  }

  private addAllCartItems() {
    MatomoEvents.forOrderTemplates.addAllProducts.publish();
    this.cartService.triggerPutAllItemsEvent();
    ApiService.defaultInfoHandler(
      this.$t('orderTemplate.orderTemplateButtons.allProductsWithQuantityHaveBeenAddedToCart').toString()
    );
  }

  private dropOrderTemplateItemsAmount() {
    Vue.prototype.$events.$emit('drop-order-template-items-amount');
    this.showOptions = false;
  }

}
